// #region Imports
import { useEffect, useState, useCallback } from 'react';
import vendasApi from '../services/vendasApi';
import { vendaFromBackend, buildItem, computeResumo } from '../pages/Vendas/venda-utils';
// #endregion

// Hook de vendas (lista + criação + remoção) e estado compartilhado de carrinho
export default function useVendas({ produtosProvider, servicosProvider, funcionariosProvider }) { // providers ainda não usados (mantidos para compatibilidade)
  // #region Estado base
  const [vendas, setVendas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // #endregion

  // #region Efeito: carga inicial
  useEffect(() => {
    let active = true;
    async function load() {
      setLoading(true);
      try {
        const raw = await vendasApi.listAll();
        if (!active) return;
        setVendas(raw.map(vendaFromBackend));
      } catch (e) {
        if (active) setError(e);
      } finally {
        if (active) setLoading(false);
      }
    }
    load();
    return () => { active = false; };
  }, []);
  // #endregion

  // #region Handlers domínio (CRUD)
  const criarVenda = useCallback(async payload => {
    const dto = await vendasApi.create({ ...payload });
    const inst = vendaFromBackend(dto);
    setVendas(prev => [inst, ...prev]);
    return inst;
  }, []);

  const removerVenda = useCallback(async id => {
    await vendasApi.remove(id);
    setVendas(prev => prev.filter(v => v.id !== id));
  }, []);
  // #endregion

  // #region Estado carrinho
  const [cart, setCart] = useState([]); // itens da nova venda

  function addProduto(prod) {
    setCart(prev => {
      const idx = prev.findIndex(i => i.tipo === 'PRODUTO' && i.ref_id === prod.id);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantidade: copy[idx].quantidade + 1 };
        return copy;
      }
      return [
        ...prev,
        buildItem({
          tipo: 'PRODUTO',
          ref_id: prod.id,
          nome: prod.nome,
          quantidade: 1,
          preco_unit: prod.preco_venda,
        }),
      ];
    });
  }

  function addServico(servico, funcionarioId) {
    if (!funcionarioId) return; // exige funcionário
    setCart(prev => [
      ...prev,
      buildItem({
        tipo: 'SERVICO',
        ref_id: servico.id,
        nome: servico.nome,
        funcionario_id: funcionarioId,
        quantidade: 1,
        preco_unit: servico.preco_padrao,
        perc_comissao: servico.perc_comissao_padrao,
      }),
    ]);
  }

  function removeItem(index) {
    setCart(prev => prev.filter((_, i) => i !== index));
  }

  function updateQuantidade(index, delta) {
    setCart(prev => prev.map((it, i) => (i === index ? { ...it, quantidade: Math.max(1, it.quantidade + delta) } : it)));
  }

  function clearCart() { setCart([]); }
  // #endregion

  // #region Derivados
  const totalCarrinho = cart.reduce((acc, i) => acc + i.preco_unit * i.quantidade, 0);
  const resumo = computeResumo(vendas);
  // #endregion

  // #region Export
  return {
    vendas,
    loading,
    error,
    criarVenda,
    removerVenda,
    cart,
    addProduto,
    addServico,
    removeItem,
    updateQuantidade,
    clearCart,
    totalCarrinho,
    resumo,
  };
  // #endregion
}
